// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Accordion2Controller from "./accordion_2_controller"
application.register("accordion-2", Accordion2Controller)

import AdditionsgruppeController from "./additionsgruppe_controller"
application.register("additionsgruppe", AdditionsgruppeController)

import AufgabeController from "./aufgabe_controller"
application.register("aufgabe", AufgabeController)

import AutoAktualisierungController from "./auto_aktualisierung_controller"
application.register("auto-aktualisierung", AutoAktualisierungController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import AutosaveTextareaController from "./autosave_textarea_controller"
application.register("autosave-textarea", AutosaveTextareaController)

import AutosubmitFormularController from "./autosubmit_formular_controller"
application.register("autosubmit-formular", AutosubmitFormularController)

import BavLeistungController from "./bav_leistung_controller"
application.register("bav-leistung", BavLeistungController)

import BerechnungStatusController from "./berechnung_status_controller"
application.register("berechnung-status", BerechnungStatusController)

import BeitragsuebersichtController from "./beitragsuebersicht_controller"
application.register("beitragsuebersicht", BeitragsuebersichtController)

import BemerkungController from "./bemerkung_controller"
application.register("bemerkung", BemerkungController)

import BesitzerController from "./besitzer_controller"
application.register("besitzer", BesitzerController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChartPlanungsvergleichController from "./chart_planungsvergleich_controller"
application.register("chart-planungsvergleich", ChartPlanungsvergleichController)

import ChartPlanungssimulationController from "./chart_planungssimulation_controller"
application.register("chart-planungssimulation", ChartPlanungssimulationController)

import ChartVermoegensverlaufController from "./chart_vermoegensverlauf_controller"
application.register("chart-vermoegensverlauf", ChartVermoegensverlaufController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import CustomAppThemeController from "./custom_app_theme_controller"
application.register("custom-app-theme", CustomAppThemeController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatumController from "./datum_controller"
application.register("datum", DatumController)

import DetailsAccordionController from "./details_accordion_controller"
application.register("details-accordion", DetailsAccordionController)

import DepotChartController from "./depot_chart_controller"
application.register("depot-chart", DepotChartController)

import DepotSteuerzuordnungController from "./depot_steuerzuordnung_controller"
application.register("depot-steuerzuordnung", DepotSteuerzuordnungController)

import DetailansichtZeitpunktFormController from "./detailansicht_zeitpunkt_form_controller"
application.register("detailansicht-zeitpunkt-form", DetailansichtZeitpunktFormController)

import DragAndDropController from "./drag_and_drop_controller"
application.register("drag-and-drop", DragAndDropController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownVertragController from "./dropdown_vertrag_controller"
application.register("dropdown-vertrag", DropdownVertragController)

import EinkunftsartController from "./einkunftsart_controller"
application.register("einkunftsart", EinkunftsartController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FormularController from "./formular_controller"
application.register("formular", FormularController)

import GeburtsdatumController from "./geburtsdatum_controller"
application.register("geburtsdatum", GeburtsdatumController)

import GkvGpvBeitragController from "./gkv_gpv_beitrag_controller"
application.register("gkv-gpv-beitrag", GkvGpvBeitragController)

import GkvGpvDetailansichtController from "./gkv_gpv_detailansicht_controller"
application.register("gkv-gpv-detailansicht", GkvGpvDetailansichtController)

import GkvgpvChartController from "./gkvgpv_chart_controller"
application.register("gkvgpv-chart", GkvgpvChartController)

import GrvBeitragController from "./grv_beitrag_controller"
application.register("grv-beitrag", GrvBeitragController)

import GrvChartController from "./grv_chart_controller"
application.register("grv-chart", GrvChartController)

import IconNavigationController from "./icon_navigation_controller"
application.register("icon-navigation", IconNavigationController)

import InputSyncController from "./input_sync_controller"
application.register("input-sync", InputSyncController)

import KartenFormController from "./karten_form_controller"
application.register("karten-form", KartenFormController)

import KartenMiniaturController from "./karten_miniatur_controller"
application.register("karten-miniatur", KartenMiniaturController)

import KartenfilterFormController from "./kartenfilter_form_controller"
application.register("kartenfilter-form", KartenfilterFormController)

import KartensortController from "./kartensort_controller"
application.register("kartensort", KartensortController)

import KindController from "./kind_controller"
application.register("kind", KindController)

import KreditInfoController from "./kredit_info_controller"
application.register("kredit-info", KreditInfoController)

import KreditChartController from "./kredit_chart_controller"
application.register("kredit-chart", KreditChartController)

import KreditStartTilgungsstartController from "./kredit_start_tilgungsstart_controller"
application.register("kredit-start-tilgungsstart", KreditStartTilgungsstartController)

import LiquidSwitcherController from "./liquid_switcher_controller"
application.register("liquid-switcher", LiquidSwitcherController)

import KreditZinsbindungAnnuitaetController from "./kredit_zinsbindung_annuitaet_controller"
application.register("kredit-zinsbindung-annuitaet", KreditZinsbindungAnnuitaetController)

import KreditZinsbindungZinsController from "./kredit_zinsbindung_zins_controller"
application.register("kredit-zinsbindung-zins", KreditZinsbindungZinsController)

import MandantenSearchController from "./mandanten_search_controller"
application.register("mandanten-search", MandantenSearchController)

import MandantenSelectController from "./mandanten_select_controller"
application.register("mandanten-select", MandantenSelectController)

import MaxOneAktivSwitchController from "./max_one_aktiv_switch_controller"
application.register("max-one-aktiv-switch", MaxOneAktivSwitchController)

import MinOneAktivSwitchController from "./min_one_aktiv_switch_controller"
application.register("min-one-aktiv-switch", MinOneAktivSwitchController)

import Modal1Controller from "./modal_1_controller"
application.register("modal-1", Modal1Controller)

import Modal2Controller from "./modal_2_controller"
application.register("modal-2", Modal2Controller)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalExecutiveSummaryController from "./modal_executive_summary_controller"
application.register("modal-executive-summary", ModalExecutiveSummaryController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedAttributeController from "./nested_attribute_controller"
application.register("nested-attribute", NestedAttributeController)

import NestedContainerController from "./nested_container_controller"
application.register("nested-container", NestedContainerController)

import NotificationPlanungController from "./notification_planung_controller"
application.register("notification-planung", NotificationPlanungController)

import NotifyController from "./notify_controller"
application.register("notify", NotifyController)

import NotizController from "./notiz_controller"
application.register("notiz", NotizController)

import OnoffswitchController from "./onoffswitch_controller"
application.register("onoffswitch", OnoffswitchController)

import PkvppvChartController from "./pkvppv_chart_controller"
application.register("pkvppv-chart", PkvppvChartController)

import RealwertController from "./realwert_controller"
application.register("realwert", RealwertController)

import ReferenzwerteController from "./referenzwerte_controller"
application.register("referenzwerte", ReferenzwerteController)

import RenteneintrittController from "./renteneintritt_controller"
application.register("renteneintritt", RenteneintrittController)

import RentenversicherungController from "./rentenversicherung_controller"
application.register("rentenversicherung", RentenversicherungController)

import ReportController from "./report_controller"
application.register("report", ReportController)

import RiesterChartController from "./riester_chart_controller"
application.register("riester-chart", RiesterChartController)

import RiesterZulageFormController from "./riester_zulage_form_controller"
application.register("riester-zulage-form", RiesterZulageFormController)

import RisikolebensversicherungController from "./risikolebensversicherung_controller"
application.register("risikolebensversicherung", RisikolebensversicherungController)

import SelectboxController from "./selectbox_controller"
application.register("selectbox", SelectboxController)

import SelectboxPolymorphicController from "./selectbox_polymorphic_controller"
application.register("selectbox-polymorphic", SelectboxPolymorphicController)

import ServicegebuehrModusController from "./servicegebuehr_modus_controller"
application.register("servicegebuehr-modus", ServicegebuehrModusController)

import SimulationProgressController from "./simulation_progress_controller"
application.register("simulation-progress", SimulationProgressController)

import TachoChartController from "./tacho_chart_controller"
application.register("tacho-chart", TachoChartController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SteuertransaktionController from "./steuertransaktion_controller"
application.register("steuertransaktion", SteuertransaktionController)

import TextbausteinController from "./textbaustein_controller"
application.register("textbaustein", TextbausteinController)

import TimeoutController from "./timeout_controller"
application.register("timeout", TimeoutController)

import TodesfallschutzController from "./todesfallschutz_controller"
application.register("todesfallschutz", TodesfallschutzController)

import ToggleeinheitController from "./toggleeinheit_controller"
application.register("toggleeinheit", ToggleeinheitController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import TurboController from "./turbo_controller"
application.register("turbo", TurboController)

import UeberliquiditaetTransaktionController from "./ueberliquiditaet_transaktion_controller"
application.register("ueberliquiditaet-transaktion", UeberliquiditaetTransaktionController)

import UebertrageDatumController from "./uebertrage_datum_controller"
application.register("uebertrage-datum", UebertrageDatumController)

import UnterkartensortController from "./unterkartensort_controller"
application.register("unterkartensort", UnterkartensortController)

import UserdashboardController from "./userdashboard_controller"
application.register("userdashboard", UserdashboardController)

import VermoegensstrukturFormularController from "./vermoegensstruktur_formular_controller"
application.register("vermoegensstruktur-formular", VermoegensstrukturFormularController)

import VersichertePersonController from "./versicherte_person_controller"
application.register("versicherte-person", VersichertePersonController)

import VertragKostenController from "./vertrag_kosten_controller"
application.register("vertrag-kosten", VertragKostenController)

import ZieliconController from "./zielicon_controller"
application.register("zielicon", ZieliconController)

import ZielsortController from "./zielsort_controller"
application.register("zielsort", ZielsortController)
